import { useMutation, useQueryClient } from '@tanstack/react-query';
import { gqlFetcher, type MutationOptions } from '../fetcher';
import { ReprocessFormResponse } from '../mutations/reprocessFormResponse.mutation';
import type {
  ReprocessFormResponseMutation,
  ReprocessFormResponseMutationVariables,
} from '../types';

export const useReprocessFormResponseMutation = (
  options?: MutationOptions<ReprocessFormResponseMutation, ReprocessFormResponseMutationVariables>,
) => {
  const queryClient = useQueryClient();

  return useMutation(gqlFetcher(ReprocessFormResponse), {
    ...options,
    onSettled: async (resp, error, variables, ctx) => {
      await options?.onSettled?.(resp, error, variables, ctx);

      queryClient.invalidateQueries({
        predicate: (query) => query.queryKey.includes('form'),
      });
    },
  });
};
